import { Box, Button, Card, Divider, Grid, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import CameraAltIcon from "@mui/icons-material/CameraAlt";

export default function CameraCaptureCard({
  label,
  required,
  hasEvidence,
  onNavigate,
  onSaveDraft,
  previewField,
}: {
  label: string;
  required?: boolean;
  hasEvidence: () => boolean;
  onNavigate: () => void;
  onSaveDraft: (values: any) => void;
  previewField?: string;
}) {
  const { values, validateForm } = useFormikContext<any>();
  const previewSrc =
    previewField && typeof values?.[previewField] === "string"
      ? values[previewField]
      : "";

  const handleClick = async () => {
    await validateForm();
    onSaveDraft(values);
    onNavigate();
  };

  return (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
      >
        <Grid>
          <Typography variant="body1">{label}</Typography>
        </Grid>
        <Divider sx={{ pb: 3, width: "100%" }} />
      </Grid>

      <Button
        style={{ borderRadius: 3 }}
        startIcon={<CameraAltIcon />}
        onClick={handleClick}
        variant="contained"
        color="secondary"
        fullWidth
        size="large"
      >
        <strong>Capture Photograph</strong>
      </Button>

      {previewSrc && (
        <>
          <br />
          <Divider sx={{ pb: 2 }} />
          <Box sx={{ width: "100%", maxHeight: 260 }}>
            <Box
              component="img"
              alt="captured-preview"
              src={previewSrc}
              sx={{
                width: "100%",
                maxHeight: 260,
                objectFit: "contain",
                borderRadius: 1,
                display: "block",
                bgcolor: "grey.100",
              }}
            />
          </Box>
        </>
      )}

      {required && !hasEvidence() && (
        <Typography sx={{ mt: 1 }} color="error" variant="body2">
          This step is required. Please capture at least one photo to continue.
        </Typography>
      )}
    </Card>
  );
}
